import React from "react"

import { AiFillHeart } from "react-icons/ai"

const Footer = () => {
    return (
        <footer
            className={ `fixed bottom-0 left-0 w-full h-auto bg-secondary text-white py-3` }
        >
            <p className="text-center text-xl font-bold tracking-wider uppercase">daudit</p>

            <div className="flex-center space-x-1">
                <p>Designed by</p>

                <a href="https://www.facebook.com/dqhuy4444" rel="noreferrer" target="_blank">
                    <span className=" font-bold underline">Pơ Híp</span>
                </a>

                <AiFillHeart fill={ "red" } size={ 20 } />
            </div>
        </footer>
    )
}

export default Footer
